import { VirtualTableCheckboxRenderer, type VirtualTableColumn } from "@snapchat/snap-design-system";

import { LensIcon } from "../../camkit/common/components";
import { DecreaseText } from "../../camkit/common/components/text";
import { type MyLensesLens } from "../../gql-generated/types";
import { IconSection } from "../../lens/components/shared";

import { BasicLensStatus } from "./BasicLensStatus";

interface CellRenderer {
    row: {
        index: number;
    };
    data: Readonly<MyLensesLens[]>;
}

const getRenderer = (fn: (lens: MyLensesLens, rowIndex: number) => React.JSX.Element) => {
    return ({ row, data }: CellRenderer) => fn(data[row.index] ?? ({} as MyLensesLens), row.index);
};

export const getColumns = (
    selectedId: string,
    setSelected: (selectedId: string) => void,
): VirtualTableColumn<MyLensesLens>[] => {
    return [
        {
            id: "rowSelector",
            width: 48,
            Cell: getRenderer((lens) => (
                <VirtualTableCheckboxRenderer
                    onChange={() => {
                        setSelected(lens.id);
                    }}
                    value={{
                        checked: lens.id === selectedId,
                        disabled: lens.unlockableId === 0,
                    }}
                />
            )),
        },
        {
            id: "icon",
            width: 72,
            Cell: getRenderer((lens) => (
                <IconSection data-testid="lens-row-icon">
                    <LensIcon size={24} src={lens.iconUrl} alt={`${lens.name} Lens Icon`} />
                </IconSection>
            )),
        },
        {
            id: "name",
            Header: "Name / ID",
            Cell: getRenderer((lens) => <DecreaseText>{lens.name}</DecreaseText>),
        },
        {
            id: "status",
            Header: "Status",
            Cell: getRenderer((lens) => <BasicLensStatus lens={lens} />),
        },
    ];
};
